// Meoks: varyant değişiminde Sepete Ekle / Benzer Ürünlere Bak butonunu güncelle
(function () {
  function findCartWrap() { return document.querySelector('.meoks-buy-row__cart'); }
  function findSimilarLink() { return document.querySelector('[data-meoks-similar]'); }

  function buildSimilarButton() {
    var ref = findSimilarLink();
    var vendor = ref ? ref.getAttribute('data-vendor') : '';
    var type = ref ? ref.getAttribute('data-type') : '';
    var pid = ref ? ref.getAttribute('data-product-id') : '';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'add-to-cart-button button meoks-similar-cta';
    btn.setAttribute('data-meoks-similar', '');
    btn.setAttribute('data-vendor', vendor);
    btn.setAttribute('data-type', type);
    btn.setAttribute('data-product-id', pid);
    btn.textContent = (window.MeoksI18n && window.MeoksI18n.misc && window.MeoksI18n.misc.viewSimilarProducts) || 'Benzer Ürünlere Bak';
    return btn;
  }

  function updateBuyRow(variant, newHtml) {
    var cart = findCartWrap();
    if (!cart) return;
    var available = variant && variant.available === true;
    if (available) {
      // Stokta var: orijinal Sepete Ekle butonunu HTML'den geri yükle
      if (newHtml) {
        var newCart = newHtml.querySelector('.meoks-buy-row__cart');
        if (newCart) cart.innerHTML = newCart.innerHTML;
      }
    } else {
      // Stokta yok: Benzer Ürünlere Bak butonu göster
      if (!cart.querySelector('.meoks-similar-cta')) {
        cart.innerHTML = '';
        cart.appendChild(buildSimilarButton());
      }
    }
  }

  ['variantUpdate', 'variant:update', 'variant-update'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      var variant = e.resource || (e.detail && (e.detail.resource || e.detail.variant));
      var html = (e.data && e.data.html) || (e.detail && e.detail.data && e.detail.data.html);
      updateBuyRow(variant, html);
    }, true);
  });
})();

// Meoks: barkod alanını varyant değişiminde günceller
(function () {
  function updateBarcode(newHtml) {
    if (!newHtml) return;
    var newBarcodeEl = newHtml.querySelector('product-barcode-component [data-testid="product-barcode"]');
    var newValue = newBarcodeEl ? newBarcodeEl.textContent.trim() : '';
    document.querySelectorAll('product-barcode-component').forEach(function (comp) {
      var span = comp.querySelector('[data-testid="product-barcode"]');
      if (span && newBarcodeEl) span.textContent = newValue;
    });
    document.querySelectorAll('[data-meoks-barcode-mirror]').forEach(function (mirror) {
      var row = mirror.closest('.meoks-pd-inline__meta-row');
      if (newValue) {
        mirror.textContent = newValue;
        if (row) row.style.display = '';
      } else if (row) {
        row.style.display = 'none';
      }
    });
    // Renk mirror — sağ panelden seçili rengi al
    var selectedColor = '';
    var colorSelected = newHtml.querySelector('.variant-option__swatch-value');
    if (colorSelected) selectedColor = colorSelected.textContent.trim();
    if (selectedColor) {
      document.querySelectorAll('[data-meoks-color-mirror]').forEach(function (m) { m.textContent = selectedColor; });
    }
  }

  ['variantUpdate', 'variant:update', 'variant-update'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      var html = (e.data && e.data.html) || (e.detail && e.detail.data && e.detail.data.html) || (e.detail && e.detail.html);
      if (html) updateBarcode(html);
    }, true);
  });
})();
